import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const createStrategy = async strategyData => {
  console.log('strategyData', strategyData)
  const url = `${baseUrl}/aws/strategy`

  //////////////////////////////////////////////////
  console.log('NEW STRATEGY DATA TO SUBMIT[MUTATION]: ', strategyData)
  const response = await axios.post(url, strategyData, {})
  return response.data // This allows the response data to be accessed in onSuccess
}

export const useCreateStrategy = () => {
  const { showSnackbar } = useSnackbarContext()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: createStrategy,
    onMutate: async newStrategy => {
      // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
      await queryClient.cancelQueries({ queryKey: ['strategy'] })

      // Snapshot the previous value
      const previousStrategy = queryClient.getQueryData(['strategy'])
      console.log(
        '[useStrategy] previousStrategy: ',
        previousStrategy ? previousStrategy : 'No Previous Strategies Cached'
      )
      // Optimistically update to the new value

      return { previousStrategy }
    },
    onError: (err, newStrategy, context) => {
      // Roll back the optimistic update
      queryClient.setQueryData(['strategy'], context.previousStrategy)
      console.error('Mutation Error:', err)
      showSnackbar((err as any).response?.data?.message || err.message, 'error')
    },
    onSuccess: data => {
      console.log('[useStrategy] onSuccess data: ', data)
      // Invalidate and refetch or update query data

      queryClient.setQueryData(['strategy'], (old: any) =>
        old ? [...old, { ...data, id: data.strategy_uuid }] : [{ ...data, id: data.strategy_uuid }]
      )
      showSnackbar('Strategy created successfully', 'success')
    },

    onSettled: () => {
      // Always refetch after error or success:
      // queryClient.invalidateQueries({ queryKey: ['strategy'] })
    },
  })

  return mutation
}
